module.exports = __webpack_public_path__ + "static/media/IMAGE-2-CHESTNUTS-desktop.02a3c15a.jpg";